import { apiFetch } from '../lib/api';

// Messages API functions
export async function getMessages(filters = {}) {
  const params = new URLSearchParams();
  
  // Add filters to query params
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });

  const queryString = params.toString();
  const url = queryString ? `/api/messages?${queryString}` : '/api/messages';
  
  const r = await apiFetch(url);
  if (!r.ok) throw new Error('Messages fetch failed');
  return r.json();
}

export async function getMessage(id) {
  const r = await apiFetch(`/api/messages?id=eq.${id}&select=*`);
  if (!r.ok) throw new Error('Message fetch failed');
  return r.json();
}

export async function createMessage(messageData) {
  const r = await apiFetch('/api/messages', {
    method: 'POST',
    body: JSON.stringify(messageData)
  });
  if (!r.ok) throw new Error('Message creation failed');
  return r.json();
}

export async function markMessagesAsRead(messageIds) {
  const r = await apiFetch('/api/mark-messages-read', {
    method: 'POST',
    body: JSON.stringify({ message_ids: messageIds })
  });
  if (!r.ok) throw new Error('Mark messages as read failed');
  return r.json();
}

export async function updateMessage(id, messageData) {
  const r = await apiFetch(`/api/messages?id=eq.${id}`, {
    method: 'PATCH',
    body: JSON.stringify(messageData)
  });
  if (!r.ok) throw new Error('Message update failed');
  return r.json();
}

export async function deleteMessage(id) {
  const r = await apiFetch(`/api/messages?id=eq.${id}`, {
    method: 'DELETE'
  });
  if (!r.ok) throw new Error('Message deletion failed');
  return r.json();
}

export async function getConversation(user1Id, user2Id, appId) {
  // Doğru OR query formatı
  const orQuery = `(and(sender_id.eq.${user1Id},receiver_id.eq.${user2Id}),and(sender_id.eq.${user2Id},receiver_id.eq.${user1Id}))`;
  
  const params = new URLSearchParams();
  params.set('select', '*');
  params.set('or', orQuery);
  params.set('order', 'created_at.asc');
  
  // Only add app filter if appId is provided and not null
  if (appId && appId !== 'null' && appId !== null) {
    params.set('app', `eq.${appId}`);
  }
  
  const r = await apiFetch(`/api/messages?${params.toString()}`);
  if (!r.ok) throw new Error('Conversation fetch failed');
  return r.json();
}

export async function getMyMessages() {
  const r = await apiFetch('/api/messages?select=*&order=created_at.desc');
  if (!r.ok) throw new Error('My messages fetch failed');
  return r.json();
}

export async function markMessageAsRead(id) {
  const r = await apiFetch(`/api/messages?id=eq.${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ 
      isRead: true,
      readAt: new Date().toISOString()
    })
  });
  if (!r.ok) throw new Error('Message mark as read failed');
  return r.json();
}

export async function getUnreadMessages() {
  const r = await apiFetch('/api/messages?isRead=eq.false&select=*');
  if (!r.ok) throw new Error('Unread messages fetch failed');
  return r.json();
}
